import { Box, Button, Modal, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RootStyled = styled(Modal)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 100,
});

export const ModalBoxStyled = styled(Box)(({ theme }) => ({
  background: theme.palette.global.white,
  padding: 24,
  borderRadius: 5,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

export const InputBoxStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 800,
  padding: 24,
  gap: '0.5rem',
});

export const FrequencyInputStyled = styled(TextField)({
  width: 174,
  zIndex: 100,
});

export const PeriodsInputStyled = styled(TextField)({
  width: 154,
});

export const DateInputStyled = styled(TextField)({
  width: 250,
});

export const ButtonStyled = styled(Button)(({ theme }) => ({
  width: 250,
  height: 54,
  margin: '1rem 0',
  alignSelf: 'center',
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.global.white,
  fontWeight: 'bold',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
    filter: 'brightness(92%)',
  },
}));
